module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_30 (36).9514aac.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_30 (36).mp4
// module id = 811
// module chunks = 1